﻿; (function ($) {
	"use strict";
    var cdnvalue = $("#cdnInput").data("value");
	const endpoint = "/api/serviceprovider/getserviceproviders";

	const searchField = document.getElementById("pac-input");
	const countryRestriction = searchField.dataset.country;
	const serviceprovidersContainer = document.querySelector("[data-serviceproviderscontainer]");
	const serviceprovidersList = document.querySelector("[data-serviceproviderslist]");
	const useMyLocationButton = document.querySelector("[data-currentlocationbutton]");
	const errormessage = document.querySelector("[data-errormessage]");

	const serviceProviderAmount = document.getElementById("serviceProviderAmount");

	const searchButton = document.querySelector("[data-search]");
	const clearSearchButton = document.querySelector("[data-clear]");

	const tagContainerId = 'news-overview-tags';
	const tagContainer = document.getElementById(tagContainerId);
	const tags = document.querySelectorAll(`#${tagContainerId} input[type="checkbox"]`);

	const useFilters = searchField.dataset.filters.toUpperCase() === "TRUE" ? true : false;
	const gasType = searchField.dataset.gastype.toUpperCase();
	const searchResultsHeadline = searchField.dataset.resultsheader;
	const servicesHeadline = searchField.dataset.filterHeadline;

	let labelCallContactPerson = '';
	let labelCallServiceProvider = '';

	let serviceProvidersMarkup = '';

	var currentLocation = {};
	var currentCounty = "";
	var distanceUnit = "";

	var autocomplete;

	// Bias the autocomplete object to the user's geographical location,
	// as supplied by the browser's 'navigator.geolocation' object.
	function geolocate() {

		if (navigator.geolocation) {

			navigator.geolocation.getCurrentPosition(function (position) {
				const geolocation = {
					lat: position.coords.latitude,
					lng: position.coords.longitude
				};

				//console.log(geolocation.lat);
				//console.log(geolocation.lng);

				const circle = new google.maps.Circle({
					center: geolocation,
					radius: position.coords.accuracy
				});
				autocomplete.setBounds(circle.getBounds());

				const geocoder = new google.maps.Geocoder;

				geocoder.geocode({
					"location": geolocation
				}, function (results, status) {
					if (status === "OK") {
						if (results[0]) {

							searchField.value = results[0].formatted_address;
							clearSearchButton.style.display = "block";
							performSearch();


						} else {
							console.log('No results found');
						}
					} else {
						console.log('Geocoder failed due to: ' + status);
					}
				});

			});
		}
	}

	function displayErrorMessage(message) {
		console.log(message);
		errormessage.style.display = "flex";
		serviceprovidersList.style.display = "none";
		serviceprovidersContainer.style.display = "block";
		updatePagination(0, 0);
		serviceProviderAmount.innerHTML = "0";
	}

	function performSearch() {
		const geocoder = new google.maps.Geocoder();
		const address = searchField.value;
		if (address.length > 0) {
			geocoder.geocode({ 'address': address }, function (results, status) {
				if (status === "OK") {

					serviceprovidersContainer.style.display = "block";
					clearSearchButton.style.display = "block";

					const filteredArray = results[0].address_components.filter(function (addressComponent) {
						return addressComponent.types.includes("administrative_area_level_1");
					});

					const county = filteredArray.length ? filteredArray[0].long_name : "";

					if (county) {
						currentLocation = results[0].geometry.location;
						currentCounty = county;
						getServiceProviders();
						errormessage.style.display = "none";
						serviceprovidersContainer.style.display = "block";
						serviceprovidersList.style.display = "flex";
					} else {
						displayErrorMessage("Sorry, no results because no county");
					}
				} else {
					displayErrorMessage(`Geocode was unsuccessful for the following reason: ${status}`);
				}
			});
		}
	}

	function resetSearch() {

		searchField.value = "";
		clearSearchButton.style.display = "none";
		serviceprovidersList.innerHTML = "";
		serviceprovidersContainer.style.display = "none";
		errormessage.style.display = "none";
	}

	function performSearchFromSpecificPlace() {
		// Get the place details from the autocomplete object.
		var place = autocomplete.getPlace();

		if (typeof place.formatted_address !== "undefined" && place.formatted_address !== null) {
			searchField.value = place.formatted_address;
			performSearch();

		}

		clearSearchButton.style.display = "block";
	}

	function initAutocomplete() {

		const options = {
			types: ["geocode"],
			componentRestrictions: {
				country: countryRestriction
			}
		};

		// Create the autocomplete object, restricting the search predictions to
		// geographical location types.
		autocomplete = new google.maps.places.Autocomplete(searchField, options);

		// Avoid paying for data that you don't need by restricting the set of
		// place fields that are returned to just the address components.
		autocomplete.setFields(["formatted_address", "address_components", "geometry", "name"]);

		// When the user selects an address from the drop-down, perform a search from this specific place
		autocomplete.addListener("place_changed", performSearchFromSpecificPlace);

		searchButton.addEventListener("click", performSearch);

		clearSearchButton.addEventListener("click", resetSearch);

		if (navigator.geolocation) {
			useMyLocationButton.removeAttribute("style");
			useMyLocationButton.addEventListener("click", geolocate);
		}
	}

	function getServiceProviders(page = 1) {

		$.post({
			url: endpoint,
			data: JSON.stringify({
				location: currentLocation,
				county: currentCounty,
				gastype: gasType,
				tags: getCheckedTagIds(),
				page
			}),
			beforeSend: function (xhr) {
				xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
			}
		})
			.done(function (data) {
				serviceProviderAmount.innerHTML = data.ServiceProviders.length;
				distanceUnit = data.DistanceUnit;
				labelCallContactPerson = data.Labels.CallPrefixForContactLabel;
				labelCallServiceProvider = data.Labels.CallUsLabel;
				renderServiceProviders(data.ServiceProviders);				
				updatePagination(data.CurrentPage, data.TotalPages);
				addSearchResultsHeader();
			})
			.fail(function (jqXHR, textStatus) {
				console.warn(textStatus);
			})
			.always(function () {
				//console.log("Always!");
			});

	}

	function addSearchResultsHeader() {
		var span = document.createElement("div");
		span.classList.add("columns");
		span.classList.add("small-12");
		span.classList.add("serviceproviders-headline");
		span.innerHTML = searchResultsHeadline;

		serviceprovidersList.prepend(span);
	}

	// Recursively build service providers markup
	function renderServiceProviders(serviceProviders) {

		if (!serviceProviders) {
			console.warn("No serviceProviders");
		}
		if (serviceProvidersMarkup === "" && serviceProviders.length === 0) {
			serviceprovidersList.innerHTML = "";
			return;
		}
		if (serviceProviders && serviceProviders.length === 0) {
			serviceprovidersList.innerHTML = serviceProvidersMarkup;
			serviceProvidersMarkup = "";
			return;
		}

		// Pass first element from articles and generate its markup
		serviceProvidersMarkup += generateServiceProvidersMarkup(serviceProviders.shift());

		// Call function with remaining list
		renderServiceProviders(serviceProviders);
	}

	function generateServicesMarkup(services) {

		let serviceList = "";

		services.forEach(function (service) {
			serviceList += `<li>${service}</li>`;
		});

		return serviceList;
	}

	function generateServiceProvidersMarkup(serviceProvider) {
		
		let trumpet = '';
		let services = '';
		let certificate = '';
		let phone = '';
		let emails = '';
		let address = '';
		let region = '';
		let city = '';
		let contactPersons = '';

		if (serviceProvider.District) {
			trumpet = `<div><small class="trumpet"><span class="preferred">${serviceProvider.District}</span></small></div>`;
		}

		if (serviceProvider.Distance) {
			trumpet = `<div><small class="trumpet">${serviceProvider.Distance}${distanceUnit}</small></div>`;
		}

		if (serviceProvider.District && serviceProvider.Distance) {
			trumpet = `<div><small class="trumpet"><span class="preferred">${serviceProvider.District}</span> &#8226; ${serviceProvider.Distance}${distanceUnit}</small></div>`;
		}
		if (serviceProvider.Company && serviceProvider.Company) {
			trumpet += `<div><strong class="trumpet">${serviceProvider.Company}</strong></div>`;
		}

		if (serviceProvider.Address.length > 0) {
			address = '<p class="address address-one">';
			address += serviceProvider.Address;
			address += '</p>';
		}

		if (serviceProvider.Phone && serviceProvider.Phone.length > 0) {

			let allPhoneNumbers = serviceProvider.Phone;
			let phoneNumberType = 'Phone';
			let hideOnMobileClass = '';

			if (allPhoneNumbers.length > 1) {
				hideOnMobileClass = 'service-card__link--hide-for-mobile';
			}

			allPhoneNumbers.forEach(function (phoneNumber) {

				if (phoneNumber.Type === "mobile") {
					phoneNumberType = 'Phone-upright';
				}

				phone += `<a class="service-card__link service-card__link--phone ${hideOnMobileClass}" href="tel: ${phoneNumber.Number}" onclick='shvenergy.tracking.trackEvent("Technical service provider", "phonenumber-click", "${phoneNumber.Number}");'>
							<svg data-phonenumbertype="${phoneNumberType}" focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#${phoneNumberType}_16x16"></use></svg>${phoneNumber.Number}
						</a>`;
			});

		}

		if (serviceProvider.Email && serviceProvider.Email.length > 0) {

			let allEmails = serviceProvider.Email;
			allEmails.forEach(function (email) {

				emails += `<a class="service-card__link" href="mailto: ${email}" onclick='shvenergy.tracking.trackEvent("Technical service provider", "email-click", "${email}");'>
							<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#E-mail_16x16"></use></svg>
							${email}
						   </a>`;
			});
		}

		if (serviceProvider.ContactPersons && serviceProvider.ContactPersons.length > 0) {
			
			let allContactPersons = serviceProvider.ContactPersons;
			allContactPersons.forEach(function (person) {

				contactPersons += `<div class="u-margin-top-tiny u-padding-top-tiny" style="border-top: solid 1px #e5e5e5;">`;

				contactPersons += `<div class="service-card__link service-card__link--full-width">
							<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#User_16x16"></use></svg>
							${person.Name}
						   </div>`;



				let allPhoneNumbers = person.Phone;
				let phoneNumberType = `<svg data-phonenumbertype="Phone" focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Phone_16x16"></use></svg>`;
				let hideOnMobileClass = '';

				if (allPhoneNumbers.length > 1) {
					hideOnMobileClass = 'service-card__link--hide-for-mobile';
				}

				allPhoneNumbers.forEach(function (phoneNumber) {

					if (phoneNumber.Type === "Mobile") {
                        phoneNumberType = `<svg data-phonenumbertype="Phone-upright" focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#Phone-upright_16x16"></use></svg>`;
					}

					contactPersons += `<a class="service-card__link service-card__link--phone service-card__link--full-width ${hideOnMobileClass}" href="tel: ${phoneNumber.Number}" onclick='shvenergy.tracking.trackEvent("Technical service provider", "phonenumber-click", "${phoneNumber.Number}");'>
						${phoneNumberType}${phoneNumber.Number}
					</a>`;
				});


				let allEmails = person.Email;
				allEmails.forEach(function (email) {

					contactPersons += `<a class="service-card__link service-card__link--full-width" href="mailto: ${email}" onclick='shvenergy.tracking.trackEvent("Technical service provider", "email-click", "${email}");'>
							<svg focusable="false" aria-hidden="true" width="16" height="16" viewBox="0 0 16 16"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#E-mail_16x16"></use></svg>
							${email}
						   </a>`;
				});

				let contactPersonFullName = person.Name;
				let contactPersonFirstName = contactPersonFullName.split(' ')[0];
                let contactPersonFirstNameCaseCorrection = '';

                if (contactPersonFirstName !== 'undefined' && contactPersonFirstName.length > 1) {
                    contactPersonFirstNameCaseCorrection = contactPersonFirstName[0].toUpperCase() + contactPersonFirstName.slice(1).toLowerCase();
                }
							
                const popupTriggerMarkup = allPhoneNumbers.length > 1 ? '<button type="button" class="service-card__link service-card__link--popup-trigger js-show-phone-numbers">' + labelCallContactPerson + ' ' + contactPersonFirstNameCaseCorrection + '</button>' : '';

				contactPersons += `${popupTriggerMarkup}
												</div>`;
			});
		}

		if (serviceProvider.Services && serviceProvider.Services.length > 0) {

			services = `<div class="u-margin-top-tiny u-padding-top-tiny" style="border-top: solid 1px #e5e5e5;">`;


			if (servicesHeadline !== "")
				services += `<p class="u-margin-top-none u-margin-bottom-none"><strong>${servicesHeadline}</strong></p>`;

			services += `<ul class="u-margin-top-none">${generateServicesMarkup(serviceProvider.Services)}</ul>`;
			services += `</div>`;
		}

		const cols = useFilters ? "large-6 xlarge-4" : "medium-6 large-4 xlarge-3";
		
		const popupTriggerMarkup = serviceProvider.Phone.length > 1 ? '<button type="button" class="service-card__link service-card__link--popup-trigger js-show-phone-numbers">' + labelCallServiceProvider + '</button>' : '';

		return `<div class="columns small-12 ${cols} service-card-container">
					<div class="service-card">
					<div class="service-card__info">
						${trumpet}
						${address}
						${phone}
						${popupTriggerMarkup}
						${emails}
						${contactPersons}
						${services}
					</div>
					${certificate}
				</div>
			</div>`;
	}

	function generateServiceProvidersPhoneOnMobileMarkup($popupTrigger) {
		
		let phoneNumbers = $popupTrigger.siblings('.service-card__link--phone');

		let phoneMarkup = '';

		phoneNumbers.each(function (phoneNumber) {
			
			let phoneNumberTypeFromData = $(this).find('svg').data('phonenumbertype');
			
			phoneMarkup += `<div class="pop-up--phonenumbers__container__division__details">
									<a href="${$(this).attr('href')}" class="pop-up--phonenumbers__container__division__link" id="dealerfinder_${$(this).text()}">
										<span class="small-icon__wrapper">
											<svg focusable="false" width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><use xlink:href="${cdnvalue}/dist/svgsprite/icons.svg#${phoneNumberTypeFromData}_16x16"></use></svg>
										</span>
										<span>${$(this).text()}</span>
									</a>
								</div>`;

		});
		
		let popupMarkup = `<div class="pop-up--phonenumbers" id="phoneNumbersOnMobile">
										<div class="pop-up--phonenumbers__container">
											<div class="pop-up--phonenumbers__container__division">
												<div class="pop-up--phonenumbers__container__division__details">
													<p class="pop-up--phonenumbers__container__division__headline">Select number to call</p>
												</div>
												${phoneMarkup}
											</div>
											<div class="pop-up--phonenumbers__container__division u-margin-top-tiny">
												<button type="button" class="pop-up--phonenumbers__container__division__close">
													<span>Cancel</span>
												</button>
											</div>
										</div>
									</div>`;
		
		$("body").append(popupMarkup);
		$("#phoneNumbersOnMobile").show();
		$("body").css('overflow', 'hidden');
		
		$(document)
			.on("click", '.pop-up--phonenumbers__container__division__close', function (e) {
					e.preventDefault();
					e.stopPropagation();
					$("#phoneNumbersOnMobile").remove();
					$("body").css('overflow', '');
			});
	}

	function toggleTagsContainer() {
		const tagNavContainer = document.querySelector(".news-list-tags");
		if (tagNavContainer.classList.contains("is-active")) {
			return tagNavContainer.classList.remove("is-active");
		}
		return tagNavContainer.classList.add("is-active");
	}

	function handleTagClick() {
		//scrollToArticleList();
		let checkedIds = getCheckedTagIds();
		getServiceProviders(1);
		updateTagCounter(checkedIds.length);
	}

	function handlePaginationClick(pageNumber) {
		//scrollToArticleList();
		getServiceProviders(pageNumber);
	}

	function updateTagCounter(number) {
		const counter = document.getElementById("tag-counter");
		counter.innerHTML = number;
		counter.style.opacity = number > 0 ? 1 : 0;
	}

	function getCheckedTagIds() {
		let checkedTags = document.querySelectorAll(`#${tagContainerId} input[type="checkbox"]:checked`);
		let ids = [];
		for (let i = 0; i < checkedTags.length; i++) {
			ids[i] = checkedTags[i].dataset.guid;
		}

		return ids;
	}

	function updatePagination(currentPage, totalPages) {
		// Looping and using querySelectorAll since there are two pagination blocks on the overview

		const shouldPaginationShow = totalPages > 1;
		const pagination = document.querySelectorAll(".pagination");
		if (!shouldPaginationShow) {
			for (let i = 0; i < pagination.length; i++) {
				pagination[i].style.opacity = 0;
			}
			return;
		} else {
			for (let i = 0; i < pagination.length; i++) {
				pagination[i].style.opacity = 1;
			}
		}

		const current = document.querySelectorAll(".pagination .pagination__current");
		for (let i = 0; i < current.length; i++) {
			current[i].innerHTML = currentPage;
			current[i].dataset.value = currentPage;
		}

		const total = document.querySelectorAll(".pagination .pagination__total");
		for (let i = 0; i < total.length; i++) {
			total[i].innerHTML = totalPages;
		}

		const next = document.querySelectorAll(".pagination .pagination__next");
		for (let i = 0; i < next.length; i++) {
			if (currentPage === totalPages) {
				next[i].setAttribute("disabled", "");
			} else {
				next[i].removeAttribute("disabled", "");
			}
		}

		const prev = document.querySelectorAll(".pagination .pagination__prev");
		for (let i = 0; i < prev.length; i++) {
			if (currentPage === 1) {
				prev[i].setAttribute("disabled", "");
			} else {
				prev[i].removeAttribute("disabled", "");
			}
		}
	}

	function setUpEventListeners() {
		// Handle tag clicks
		for (let i = 0; i < tags.length; i++) {
			tags[i].addEventListener("change", handleTagClick);
		}

		// Handle prev pagination clicks
		let prev = document.querySelectorAll(".pagination .pagination__prev");
		for (let i = 0; i < prev.length; i++) {
			prev[i].addEventListener("click", () => {
				let pageNumber = document.querySelector(".pagination .pagination__current").dataset.value;
				handlePaginationClick(parseInt(pageNumber) - 1);
			});
		}

		// Handle next pagination clicks
		let next = document.querySelectorAll(".pagination .pagination__next");
		for (let i = 0; i < next.length; i++) {
			next[i].addEventListener("click", () => {
				let pageNumber = document.querySelector(".pagination .pagination__current").dataset.value;
				handlePaginationClick(parseInt(pageNumber) + 1);
			});
		}

		// Handle click tag toggle  (on mobile) if it is present on the page.

		if (document.getElementById('tag-toggle')) {

			document.getElementById('tag-toggle').addEventListener("click", () => {
				//scrollToArticleList();
				toggleTagsContainer();
			});

			// Handle clicking tag back button (on mobile)
			document.getElementById("tag-back").addEventListener("click", toggleTagsContainer);
		}

		document.addEventListener("click", function (event) {

				if (event.target.classList.contains("js-show-phone-numbers")) {

						let $popupTrigger = $(event.target);
						generateServiceProvidersPhoneOnMobileMarkup($popupTrigger);
				}
		})



		// Scroll and resize listeners for sticky tags
		//window.addEventListener("scroll", handleScroll, false);
		//window.addEventListener("resize", () => (mainNavHeight = getNavHeight()));
	}

	initAutocomplete();

	setUpEventListeners();

})(jQuery);